import React, { Suspense, useEffect } from 'react'
import { Canvas, useThree } from '@react-three/fiber'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

const Model = ({Item}) => {
  const CameraController = () => {
    const { camera, gl } = useThree();
    useEffect(
      () => {
        const controls = new OrbitControls(camera, gl.domElement);
  
        controls.minDistance = 3;
        controls.maxDistance = 20;
        return () => {
          controls.dispose();
        };
      },
      [camera, gl]
    );
    return null;
  };

  return (
    <Canvas style={{ background: 'grey' }}>
      <CameraController />
      <ambientLight intensity={1} />
      <spotLight intensity={0.4} angle={4} penumbra={1.5} position={[10, 15, 10]}  castShadow /> 
      <Suspense fallback={null}>
        {/* <Canos /> */}
        <Item />
      </Suspense>
    </Canvas>
  )
}

export default Model
